export default __webpack_public_path__ + "static/media/Db_2.1199b2b2.png";